import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignInPageComponent } from './sign-in-page.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { ContactUsFooterModule } from '../../shared/contact-us-footer/contact-us-footer.module';
import { QpMatCardGreenedModule } from '../../shared/qp-mat-card-greened/qp-mat-card-greened.module';
import { SignInPageRoutingModule } from './sign-in-page-routing.module';
import { CoreModule } from '../../core/core.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [SignInPageComponent, LoginFormComponent],
  imports: [
    CommonModule,
    SignInPageRoutingModule,
    ContactUsFooterModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    QpMatCardGreenedModule,
    CoreModule,
    MatSnackBarModule,
  ],
  providers: [],
})
export class SignInPageModule {}
